// Note layouts per product handle — generated from shop.ayasainstruments.com (2026-07-26)
// Used by the product template to render the note-map SVG. Edit freely.
const PRODUCT_NOTES = {
  "fis-low-pygmy-12-ember-steel": {
    "title": "F# Low Pygmy 12 - Ember Steel",
    "ding": "F#3",
    "top": ["G#3","A3","C#4","E4","F#4","G#4","A4","C#5","E5","F#5","G#5"],
    "bottom": [],
    "spec": "F# Minor pentatonic scale"
  },
  "d-ashakiran-19-ember-steel-spotted": {
    "title": "D Ashakiran 19 - Ember Steel - Spotted",
    "ding": "D3",
    "top": [
      "G3",
      "A3",
      "B3",
      "C#4",
      "D4",
      "E4",
      "F#4",
      "A4",
      "B4",
      "F#5"
    ],
    "bottom": [
      "E3",
      "F#3",
      "G4",
      "C#5",
      "D5",
      "E5",
      "G5",
      "A5"
    ],
    "spec": ""
  },
  "fis-low-pygmy-21-ember-steel": {
    "title": "F# Low Pygmy 21 - Ember Steel",
    "ding": "F#3",
    "top": [
      "G#3",
      "A3",
      "C#4",
      "E4",
      "F#4",
      "G#4",
      "A4",
      "C#5",
      "E5",
      "F#5",
      "G#5"
    ],
    "bottom": [
      "D3",
      "E3",
      "B3",
      "D4",
      "B4",
      "D5",
      "A5",
      "B5",
      "C#6"
    ],
    "spec": ""
  },
  "d-aegean-18-ember-steel": {
    "title": "D Aegean 18 - Ember Steel",
    "ding": "D3",
    "top": [
      "F#3",
      "A3",
      "C#4",
      "D4",
      "F#4",
      "G#4",
      "A4",
      "C#5",
      "D5",
      "F#5"
    ],
    "bottom": [
      "B2",
      "E3",
      "G#3",
      "B3",
      "E4",
      "B4",
      "E5"
    ],
    "spec": ""
  },
  "e-amara-20-ember-steel-scratched": {
    "title": "E-Amara 20 Ember Steel - Scratched",
    "ding": "E3",
    "top": [
      "B3",
      "D4",
      "E4",
      "F#4",
      "G4",
      "A4",
      "B4",
      "D5",
      "E5",
      "F#5",
      "G5",
      "A5"
    ],
    "bottom": [
      "C3",
      "D3",
      "F#3",
      "G3",
      "A3",
      "C4",
      "C5"
    ],
    "spec": ""
  },
  "fis-kurd-20-ember-steel": {
    "title": "F# Kurd 20 - Ember Steel",
    "ding": "F#3",
    "top": [
      "C#4",
      "D4",
      "E4",
      "F#4",
      "G#4",
      "A4",
      "B4",
      "C#5",
      "D5",
      "E5",
      "F#5",
      "G#5",
      "A5"
    ],
    "bottom": [
      "C#3",
      "D3",
      "E3",
      "G#3",
      "A3",
      "B3"
    ],
    "spec": ""
  },
  "b2-aavartan-17-ember-steel": {
    "title": "B2 Aavartan 17 - Ember Steel",
    "ding": "B2",
    "top": [
      "D#3",
      "F#3",
      "G#3",
      "Bb3",
      "B3",
      "C#4",
      "D#4",
      "F#4"
    ],
    "bottom": [
      "C#3",
      "E3",
      "E4",
      "G#4",
      "B4",
      "C#5",
      "D#5",
      "E5"
    ],
    "spec": ""
  },
  "d-kurd-14-ember-steel": {
    "title": "D Kurd 14 - Ember Steel",
    "ding": "D3",
    "top": [
      "A3",
      "Bb3",
      "C4",
      "D4",
      "E4",
      "F4",
      "G4",
      "A4",
      "C5",
      "D5",
      "E5"
    ],
    "bottom": [
      "F3",
      "G3"
    ],
    "spec": ""
  },
  "e-amara-20-ember-steel": {
    "title": "E-Amara 20 Ember Steel",
    "ding": "E3",
    "top": [
      "B3",
      "D4",
      "E4",
      "F#4",
      "G4",
      "A4",
      "B4",
      "D5",
      "E5",
      "F#5",
      "G5",
      "A5"
    ],
    "bottom": [
      "C3",
      "D3",
      "F#3",
      "G3",
      "A3",
      "C4",
      "C5"
    ],
    "spec": ""
  },
  "e-equinox-19-ember-steel": {
    "title": "E Equinox 19 - Ember Steel",
    "ding": "E3",
    "top": [
      "G3",
      "B3",
      "C4",
      "E4",
      "F#4",
      "G4",
      "A4",
      "B4",
      "C5",
      "D5",
      "E5",
      "F#5"
    ],
    "bottom": [
      "B2",
      "C3",
      "D3",
      "A3",
      "D4",
      "G5"
    ],
    "spec": ""
  },
  "e-asha-20-ember-steel": {
    "title": "E Asha 20 Ember Steel",
    "ding": "E3",
    "top": [
      "A3",
      "B3",
      "C#4",
      "D#4",
      "E4",
      "F#4",
      "G#4",
      "A4",
      "B4",
      "C#5",
      "F#5"
    ],
    "bottom": [
      "C#3",
      "D#3",
      "F#3",
      "G#3",
      "D#5",
      "E5",
      "G#5",
      "A5"
    ],
    "spec": ""
  },
  "d-kurd-13-ember-steel": {
    "title": "D Kurd 13 - Ember Steel",
    "ding": "D3",
    "top": [
      "A3",
      "Bb3",
      "C4",
      "D4",
      "E4",
      "F4",
      "G4",
      "A4",
      "C5",
      "D5"
    ],
    "bottom": [
      "F3",
      "G3"
    ],
    "spec": ""
  },
  "c-ashakiran-17-ember-steel": {
    "title": "C Ashakiran 17 - Ember Steel",
    "ding": "C3",
    "top": [
      "F3",
      "G3",
      "A3",
      "B3",
      "C4",
      "D4",
      "E4",
      "G4"
    ],
    "bottom": [
      "D3",
      "E3",
      "F4",
      "A4",
      "B4",
      "C5",
      "D5",
      "E5"
    ],
    "spec": ""
  },
  "d-kurd-12-ember-steel": {
    "title": "D Kurd 12 - Ember Steel",
    "ding": "D3",
    "top": [
      "A3",
      "Bb3",
      "C4",
      "D4",
      "E4",
      "F4",
      "G4",
      "A4",
      "C5"
    ],
    "bottom": [
      "F3",
      "G3"
    ],
    "spec": ""
  },
  "d-aegean-20-ember-steel": {
    "title": "D Aegean 20 - Ember Steel",
    "ding": "D3",
    "top": [
      "F#3",
      "A3",
      "C#4",
      "D4",
      "F#4",
      "G#4",
      "A4",
      "C#5",
      "D5",
      "F#5",
      "G#5",
      "A5"
    ],
    "bottom": [
      "B2",
      "E3",
      "G#3",
      "B3",
      "E4",
      "B4",
      "E5"
    ],
    "spec": ""
  },
  "d-kurd-19-ember-steel": {
    "title": "D Kurd 19 - Ember Steel",
    "ding": "D3",
    "top": [
      "A3",
      "Bb3",
      "C4",
      "D4",
      "E4",
      "F4",
      "G4",
      "A4",
      "C5",
      "D5",
      "E5",
      "F5"
    ],
    "bottom": [
      "Bb2",
      "C3",
      "F3",
      "G3",
      "G5",
      "A5"
    ],
    "spec": ""
  },
  "b3-pygmy-20-ember-steel": {
    "title": "B3 Pygmy 20 - Ember Steel",
    "ding": "B3",
    "top": [
      "C#4",
      "D4",
      "D#4",
      "A4",
      "B4",
      "C#5",
      "D5",
      "F#5",
      "A5",
      "B5",
      "C#6",
      "D6"
    ],
    "bottom": [
      "F#3",
      "G3",
      "A3",
      "G4",
      "E5",
      "G5"
    ],
    "spec": ""
  },
  "fis-kurd-22-ember-steel": {
    "title": "F# Kurd 22 - Ember Steel",
    "ding": "F#3",
    "top": [
      "C#4",
      "D4",
      "E4",
      "F#4",
      "G#4",
      "A4",
      "B4",
      "C#5",
      "D5",
      "E5",
      "F#5",
      "G#5",
      "A5",
      "B5",
      "C#6"
    ],
    "bottom": [
      "B2",
      "D3",
      "E3",
      "G#3",
      "A3",
      "B3"
    ],
    "spec": ""
  },
  "fis2-nordlys-16-ember-steel": {
    "title": "F#2 Nordlys 16 - Ember Steel",
    "ding": "F#2",
    "top": [
      "F#3",
      "G#3",
      "A#3",
      "C4",
      "C#4",
      "F4",
      "G#4",
      "C5"
    ],
    "bottom": [
      "A#2",
      "C#3",
      "F3",
      "F#4",
      "C#5",
      "F5",
      "G#5"
    ],
    "spec": ""
  }
};
